import { NavLink } from 'react-router-dom'
import cx from 'classnames'

type Props = {
  title: string
  to: string
  isDisabled?: boolean
  disabledTooltipMessage?: string
}

const SubNavItem = ({ title, to, isDisabled }: Props) => {
  return (
    <NavLink
      data-cy={`subnav-link-${title}`}
      exact
      to={to}
      onClick={(event) => {
        if (isDisabled) {
          event.preventDefault()
        }
      }}
      className={cx('pl-2 pr-4', { 'cursor-not-allowed': isDisabled })}
      activeClassName="text-coolGray-800"
    >
      {title}
    </NavLink>
  )
}

export default SubNavItem
